import { createFileRoute } from "@tanstack/react-router";
import CardListingSettings from "@/pages/admin/CardListingSettings";

export const Route = createFileRoute("/admin/card-listing-settings")({
  component: CardListingSettings,
});
